import React, { useEffect } from 'react';
import { Cards, Icon } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';

const pageSize = 20;

export const LogsPage = () => {
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    useEffect(() => {
        //handleRefresh();
    }, []);
    const handleOption = (ref:string) => {
        window.location.href=ref
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Reportes', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Cards
                        //selectionType="single"
                        onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
                        cardDefinition={{
                            
                            header: item => item.name
                            ,
                            sections: [
                                {
                                    header: "",
                                    content: item => item.description
                                },
                            ]
                        }}
                        cardsPerRow={[
                            { cards: 1 },
                            { minWidth: 500, cards: 3 }
                        ]}
                        entireCardClickable
                        items={[
                            {
                                id:"#security/policies",
                                name: "Políticas",
                                description: "Generador de políticas de acceso basadas en horario y días semanales",
                            },
                            {
                                id:"#security/exclusions",
                                name: "Exclusiones",
                                description: "Configuración de anulación de aperturas remotas para accesos basado en horario y días semanales",
                            },
                            {
                                id:"#security/assign",
                                name: "Asignaciones",
                                description: "Permite asignar una o más políticas de acceso a un acceso, unidad o usuario",
                            },
                            {
                                id:"#security/geolocalization",
                                name: "Geolocalización",
                                description: "Configuración de restricciones de distancia mínima sobre uno o más accesos",
                            },
                            {
                                id:"#security/blocks",
                                name: "Bloqueos",
                                description: "Anular los servicios de LlaveMovil temporalemente a un acceso, unidad o usuario",
                            },
                        ]}
                        header={<Header><Icon name="script"></Icon> Opciones</Header>}
                    />
                </>
            }
        />
    );
};
